import * as React from 'react'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'
import './styles.scss'

export interface InputProps extends React.ComponentPropsWithRef<'input'> {}

export const InputPassword = ({ ...rest }: InputProps) => {
  const [showPass, setShowPass] = React.useState<boolean>(false)

  const handleFieldType = (): string => {
    return showPass ? 'text' : 'password'
  }

  const showPassToggle = (): void => {
    setShowPass(!showPass)
  }

  const showPassToggleContent = (): React.ReactNode => {
    return (
      <div onClick={showPassToggle}>
        {!showPass ? <MdVisibility /> : <MdVisibilityOff />}
      </div>
    )
  }

  return (
    <>
      <input {...rest} type={handleFieldType()} />
      {showPassToggleContent()}
    </>
  )
}
